import Vue from "vue/dist/vue"

/** ngProgress for ajax calls */
import NProgress from "vue-nprogress"
Vue.use(NProgress)
const nprogress = new NProgress()
import MyNProgress from './components/NProgress'
Vue.component('my-nprogress', MyNProgress)
/** ngProgress for ajax calls */

/**leftSide slider */
import { Carousel, Slide } from "vue-carousel"

/**send ajax request */
import Axios from "axios"
// Axios.defaults.baseURL = URL

/**v-animate-css */
import VAnimateCss from "v-animate-css"
Vue.use(VAnimateCss)

/**VeeValidate validation */
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate"
import { required, confirmed, min } from "vee-validate/dist/rules"
import fa from "vee-validate/dist/locale/fa"

extend("required", required)
extend("confirmed", confirmed)
extend("min", min)
/**custom national code rule */
extend('nationalcode', {
  validate: (value) => {
    if (!/^\d{10}$/.test(value)) return false

    if (/^(\d)\1+$/.test(value)) return false

    var check = +value[9]
    var sum =
      Array(9)
        .fill()
        .map((_, i) => +value[i] * (10 - i))
        .reduce((x, y) => x + y) % 11
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11)
  },
  message: 'قالب شماره ملی وارد شده صحیح نیست',
})

/**custom password strength rule */
extend("strenghtPassword", {
  validate: (value) => {
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
    return re.test(value)
  },
  message: "رمز وارد شده باید ترکیبی از حروف کوچک a-z و حروف بزرگ A-Z و اعداد و سیمبل ها ! @ # $ باشد",
})

localize("fa", fa)

// ***__Notifications__ (StarT)***
import Notifications from "vue-notification"
Vue.use(Notifications)
// ***__Notifications__ (EnD)***

/**timer countDown */
import VueCountdown from "@chenfengyuan/vue-countdown"

/**don't show the production tip in logs */
Vue.config.productionTip = false;

/**make devtools off in production */
if (process.env.MIX_APP_ENV == 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

/**vue js modal */
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
Vue.use(VModal)

new Vue({
  el: "#login",
  nprogress,
  data() {
    return {
      nationalcode: null,
      password: null,
      confirmation: null,
      verifyCode: null,
      counting: null,
      rotate: null,
      timer: timer,
      mobile: null,
      mobileCoded: null,
      fullName: null,
      /**
       * pages : 
       * 'loign' , 'new-sign'
       */
      page: 'login',

      //** test data of reset password */
      verficationCode: false,
    }
  },
  components: {
    Carousel,
    Slide,
    ValidationObserver,
    ValidationProvider,
    VueCountdown
  },
  methods: {
    /**Login */
    async LoginBtn() {
      /**check validation */
      let validate = await this.$refs.loginObserver.validate()
      if (!validate) {
        /**validation failed */
        this.$notify({
          text: "لطفا ورودی ها را چک نمایید!",
          type: "warn",
          title: "اخطار!",
          ignoreDuplicates: true,
        })
        return
      }

      /**send login request */
      try {
        let data = {
          nationalcode: this.nationalcode,
          password: this.password,
        }
        this.$nprogress.done()
        this.$nprogress.start()
        this.$nprogress.inc(0.3)
        let res = await Axios.post("/authenticate", data)

        /**
         * check the special mode
         * if user not exists but its came from the fund
         */
        if (res.status === 201) {
          this.mobile = res.data.mobile
          this.mobileCoded = res.data.mobileCoded
          this.fullName = res.data.fullName
          this.page = 'new-sign'
          this.$refs.newSignObserver.reset()
          this.$nprogress.done()
          return
        }

        this.$notify({
          text: "ورود موفقیت آمیز!",
          type: "success",
        })
        this.$nprogress.inc(0.7)
        setTimeout(function () {
          location.href = '/dashboard'
        }, 200)
        this.$nprogress.done()
      } catch (error) {
        this.$nprogress.done()
        console.error(error)
        this.$notify({
          text: "نام کاربری یا کلمه عبور اشتباه است.",
          type: "error",
          title: "هشدار!",
          ignoreDuplicates: true,
        })
      }
    },

    /** Reset Password */
    async nextLevelTOResetPassword() {
      let validate = await this.$refs.ResetPasswordObserver.validate()
      if (!validate) {
        this.$notify({
          text: "لطفا ورودی ها را چک نمایید!",
          type: "warn",
          title: "اخطار!",
          ignoreDuplicates: true,
        })
        return
      }

      /**check user signed up before or not */
      try {
        let data = {
          nationalcode: this.nationalcode,
        }
        this.$nprogress.done()
        this.$nprogress.start()
        await Axios.post("/get-investor", data)
        /**investor exists! signup abort! */
        /**everything is ok go next level */

      } catch (error) {
        /**user not found */

        await Swal.fire({
          title: '',
          html: 'شما قبلا در صندوق ثبت نام نکرده اید! <br> لطفا ابتدا در صندوق ثبت نام نمایید.',
          icon: 'info',
          confirmButtonText: 'بسیارخب',
          showClass: {
            popup: 'animated fadeIn'
          },
          hideClass: {
            popup: 'animated fadeOut'
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
        location.href = 'register'
      }

      /**user exists send verify code */
      try {
        let data = {
          nationalcode: this.nationalcode,
        }
        this.$nprogress.done()
        this.$nprogress.start()
        this.$nprogress.inc(0.2)
        let res = await Axios.post("/send-verify", data)

        /**sms sent - go nextlevel */
        this.mobile = res.data.mobile
        this.mobileCoded = res.data.mobileCoded
        this.fullName = res.data.fullName

        this.verficationCode = true
        this.$nprogress.done()
      } catch (error) {
        this.$nprogress.done()
        console.error(error)
      }

    },

    /**
     * Reset password
     */
    async resetPassword() {
      let vr = await this.$refs.ResetPasswordObserver.validate()
      if (!vr) {
        this.$notify({
          text: "لطفا ورودی ها را چک نمایید!",
          type: "warn",
          title: "اخطار!",
          ignoreDuplicates: true,
        })
        return
      }

      /**
       * verifications steps: 
       * 3- check verify sms code
       * 4- submit user and login
       */

      /**
       * 1- check nationalcode unique
       */
      this.$nprogress.done()
      this.$nprogress.start()

      /** 3- check sms verify */
      try {
        let data = {
          method: 'checkVerify',
          confirmCode: this.verifyCode,
          mobile: this.mobile
        }
        this.$nprogress.inc(0.5)
        await Axios.post('action', data)
      } catch (error) {
        this.$nprogress.done()
        console.log(error)
        this.$notify({
          text: 'کد تایید وارد شده صحیح نمی باشد.',
          type: 'error',
          title: 'اخطار'
        })
        return
      }

      /**
       * everything is ok
       * resetPassword
       */
      try {
        await Axios.post('/action', {
          method: 'resetPassword',
          nationalcode: this.nationalcode,
          password: this.password
        })
        this.$notify({
          text: 'تغییر کلمه عبور با موفقیت انجام شد!',
          type: 'success'
        })
        this.$nprogress.done()
        this.page = 'login'

      } catch (error) {
        console.error(error)
      }

    },

    /**ForgetPassword */
    ForgetPassword() {
      this.page = 'forget-password'
    },

    /**Support */
    Support() {
      return
      this.$notify({
        type: "warn",
        text: "Called From src/pages/index/UserLogin Support icon Method",
        title: "Support",
      })
    },

    /**Whatsapp */
    Whatsapp() {
      return
      this.$notify({
        type: "warn",
        text: "Called From src/pages/index/UserLogin Whatsapp icon Method",
        title: "Whatsapp",
      })
    },

    /**MoreInfo */
    MoreInfo() {
      return
      this.$notify({
        type: "warn",
        text: "Called From src/pages/index/UserLogin MoreInfo icon Method",
        title: "MoreInfo",
      })
    },

    /**backToLogin */
    backToLogin() {
      this.$nprogress.done()
      this.$nprogress.start()
      this.$nprogress.inc(0.5)
      this.verficationCode = false
      this.page = 'login'
      this.$nprogress.done()
    },

    async submitNewUser() {
      let validate = await this.$refs.newSignObserver.validate()
      if (!validate) {
        this.$notify({
          type: 'error',
          text: 'خطاهای رخ داده را برطرف نمایید'
        })
        return
      }

      /**
       * verifications steps: 
       * 1- check nationalCode unique
       * 2- check mobile unique
       * 3- check verify sms code
       * 4- submit user and login
       */

      /**
       * 1- check nationalcode unique
       */
      this.$nprogress.done()
      this.$nprogress.start()
      try {
        let data = {
          method: 'checkUserUnique',
          nationalcode: this.nationalcode,
        }
        await Axios.post('action', data)
      } catch (error) {
        this.$nprogress.done()
        console.log(error)
        this.$notify({
          text: 'این کد ملی قبلا در سامانه ثبت شده است',
          type: 'error',
          title: 'اخطار'
        })
        return
      }

      /** 2- check mobile unique */
      try {
        let data = {
          method: 'checkMobileUnique',
          mobile: this.mobile
        }
        this.$nprogress.inc(0.3)
        await Axios.post('action', data)
      } catch (error) {
        this.$nprogress.done()
        console.log(error)
        this.$notify({
          text: 'شما با این شماره همراه قبلا ثبت نام کرده اید',
          type: 'error',
          title: 'اخطار'
        })
        return
      }

      /** 3- check sms verify */
      try {
        let data = {
          method: 'checkVerify',
          confirmCode: this.verifyCode,
          mobile: this.mobile
        }
        this.$nprogress.inc(0.5)
        await Axios.post('action', data)
      } catch (error) {
        this.$nprogress.done()
        console.log(error)
        this.$notify({
          text: 'کد تایید وارد شده صحیح نمی باشد.',
          type: 'error',
          title: 'اخطار'
        })
        return
      }

      /**
       * everything is ok
       * submit the user
       */
      try {
        await Axios.post('/action', {
          method: 'submitUserFromFund',
          nationalcode: this.nationalcode,
          mobilt: this.mobile,
          password: this.password
        })
        this.$notify({
          title: 'موفقیت آمیز!',
          text: 'در حال انتقال به داشبورد...',
          type: 'success'
        })

        setTimeout(function () {
          location.href = '/dashboard'
        }, 500)

      } catch (error) {
        console.error(error)
      }

    },

    /**
     * send code again
     */
    async sendAgain() {
      /**send sms request */
      try {

        let data = {
          method: 'sendVerifyCode',
          mobile: this.mobile,
          template: 55700
        }
        this.$nprogress.inc(0.5)
        await Axios.post("/action", data)
        this.rotate = true
        this.timer = timer
        setTimeout(() => {
          this.counting = true
        }, 1000)
        this.isVerifySent = true
        this.$nprogress.done()
      } catch (error) {
        this.$nprogress.done()
        console.error(error)
        this.$notify({
          text: "خطایی رخ داده است ، لطفا بعدا تلاش کنید",
          type: "warn",
          title: "هشدار!",
          ignoreDuplicates: true,
        })
      }
    },

    /**onCountdownEnd */
    onCountdownEnd() {
      this.rotate = false
      this.counting = false
    },

  },
  mounted(){
    this.$modal.show("notifModal")
  }
})
